import React, { useEffect, useRef, useState } from "react";
import "../Website.css";
import CareerFooter from "./AboutUs/CareerFooter";
import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
import Header from '../components/common/Header';
import { useNavigate } from "react-router-dom";
// Section Components


const SectionHighlights = () => {
  return (
    <div className="tw-text-white tw-mx-auto tw-container">
      {/* TOP Highlight Section */}
      <section className="tw-flex tw-justify-center tw-items-start tw-px-4 tw-pb-6">
        <div className="tw-bg-gradient-to-b tw-from-[#184B99] tw-to-[#081933] tw-rounded-b-[3rem] tw-w-full tw-max-w-6xl tw-h-[6rem] tw-relative tw-flex tw-justify-center">
          <h1 className="tw-absolute tw-top-[3rem] tw-text-[1.3rem] sm:tw-text-[2rem] md:tw-text-[48px] lg:tw-text-[65px] tw-font-bold tw-text-center tw-flex tw-gap-2 tw-flex-wrap">
            <span className="tw-text-white tw-drop-shadow-md">We</span>
            <span className="tw-animate-flicker">Broke</span>
            <span className="tw-text-white tw-drop-shadow-md">
              The Broken Job Hunt.
            </span>
          </h1>
        </div>
      </section>

      {/* Scroll Animation Section */}
      <section className="tw-relative tw-overflow-hidden tw-py-10">
        <div className="tw-text-center tw-px-4">
          <motion.h4
            className="tw-text-[clamp(1.25rem,2vw,2rem)] tw-text-white/80"
          >
            Picture this:
          </motion.h4>
          <motion.h2
            className="tw-text-[clamp(1.25rem,3vw,2.5rem)] md:tw-text-[2.75rem] tw-font-bold"
          >
            You are job hunting and you've got
          </motion.h2>
        </div>

        {/* Scattered Text */}
        <div className="tw-relative tw-w-full tw-h-[200px] sm:tw-h-[250px] md:tw-h-[400px] lg:tw-h-[450px] tw-mt-8 tw-px-2">
          {/* 15 browser tabs */}
          <motion.p
            className="tw-absolute tw-top-[8%] tw-left-[5%] tw-font-semibold tw-text-[clamp(1.1rem,2vw,1.75rem)] md:tw-text-[2rem] tw-text-[#0076FF] tw-drop-shadow-md"
          >
            15 browser tabs open
          </motion.p>

          {/* LinkedIn */}
          <motion.div className="tw-absolute tw-top-[25%] md:tw-left-[70%] tw-left-1/2 tw--translate-x-1/2 tw-w-full tw-flex tw-justify-center">
            <p className="tw-font-semibold tw-text-center tw-text-[clamp(1.1rem,2vw,1.75rem)] md:tw-text-[2rem] tw-text-[#3E97FF] tw-drop-shadow-md">
              LinkedIn for networking
            </p>
          </motion.div>

          {/* Coursera */}
          <motion.p className="tw-absolute tw-top-1/2 tw-left-1/2 md:tw-left-[35%] tw--translate-x-1/2 tw--translate-y-1/2 tw-font-semibold tw-text-[clamp(1rem,2vw,1.5rem)] md:tw-text-[1.75rem] tw-text-[#0076FF] tw-drop-shadow-md">
            Coursera for skills
          </motion.p>

          {/* Canva */}
          <motion.div className="tw-absolute tw-top-[65%] md:tw-left-[70%] tw-left-1/2 tw--translate-x-1/2 tw-w-full tw-flex tw-justify-center">
            <p className="tw-font-semibold tw-text-center tw-text-[clamp(1.1rem,2vw,1.75rem)] md:tw-text-[2rem] tw-text-[#0052B2] tw-drop-shadow-md">
              Canva for resumes
            </p>
          </motion.div>

          {/* Indeed */}
          <motion.p className="tw-absolute tw-bottom-[5%] tw-left-[8%] tw-font-semibold tw-text-[clamp(1.1rem,2vw,1.75rem)] md:tw-text-[2rem] tw-text-[#003B80] tw-drop-shadow-md">
            Indeed for jobs
          </motion.p>
        </div>
      </section>

      {/* Closing Line */}
      <div className="tw-text-center tw-px-4">
        <motion.h2 className="tw-text-[18px] sm:tw-text-[28px] md:tw-text-[36px] lg:tw-text-[44px] tw-font-bold">
          and somehow, you're still confused about what you should actually be
          doing.
        </motion.h2>
      </div>
    </div>
  );
};


const ImageSection = () => {
  const lines = [
    "That was us.",
    "And honestly, that was everyone we knew.",
  ];

  const [typedLines, setTypedLines] = useState(["", ""]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (currentLineIndex >= lines.length) return;

    const currentLine = lines[currentLineIndex];

    if (charIndex < currentLine.length) {
      const timeout = setTimeout(() => {
        const updatedLines = [...typedLines];
        updatedLines[currentLineIndex] += currentLine[charIndex];
        setTypedLines(updatedLines);
        setCharIndex(charIndex + 1);
      }, 70);

      return () => clearTimeout(timeout);
    } else {
      const lineTimeout = setTimeout(() => {
        setCurrentLineIndex(currentLineIndex + 1);
        setCharIndex(0);
      }, 600);

      return () => clearTimeout(lineTimeout);
    }
  }, [charIndex, currentLineIndex, typedLines, lines]);

  return (
    <section className="tw-relative tw-overflow-hidden tw-h-[60vh] tw-min-h-[300px]">
      {/* Full screen background image */}
      <img
        src="/images/shutterstock-2473271441-10.png"
        alt="Background"
        className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      />

      {/* Centered typewriter text */}
      <div className="tw-relative tw-z-10 tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 md:tw-px-16 lg:tw-px-32 tw-text-center tw-gap-3">
        <h2 className="tw-text-white tw-font-semibold tw-border-r-2 tw-border-white tw-pr-1 tw-text-[clamp(1.25rem,3vw,2.5rem)]">
          {typedLines[0]}
        </h2>
        <h2 className="tw-text-white tw-font-semibold tw-border-r-2 tw-border-white tw-pr-1 tw-text-[clamp(1.25rem,3vw,2.5rem)]">
          {typedLines[1]}
        </h2>
      </div>
    </section>
  );
};

const SectionHighlightsOne = () => {
  return (
    <section className="tw-text-white">
      <div className="tw-py-12">
        {/* Top Text */}
        <div className="tw-text-center">
          <h1
            style={{
              textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)',
            }}
            className="tw-font-bold tw-mb-4 tw-text-[clamp(2rem,6vw,4rem)]"
          >
            "Hold My Coffee" Moment
          </h1>
          <p className="tw-text-[clamp(1rem,2vw,1.25rem)] tw-text-gray-300">
            The problem wasn't you, us or people—it was the scattered tools,
            confusing processes, and{" "}
            <br className="tw-hidden sm:tw-inline" />
            missing connections. So we built something better.
          </p>
        </div>

        {/* Content Block */}
        <div className="tw-w-full tw-bg-[#184B99] tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-justify-center tw-mt-20 tw-relative tw-gap-4 lg:tw-gap-1 tw-py-12 tw-px-4 lg:tw-px-0">
          {/* Left Text */}
          <div className="tw-flex-[2] tw-w-full tw-px-2 lg:tw-px-[55px]">
            <p className="tw-text-[clamp(1rem,2vw,1.5625rem)] tw-leading-[1.6] tw-text-center lg:tw-text-left">
              We're former job seekers, career coaches, and tech leaders who got
              fed up watching talented people struggle with a broken system.
              We've been the desperate grad refreshing job boards at 2 AM and
              the recruiter drowning in identical resumes.
            </p>
          </div>

          {/* Right Image */}
          <div className="tw-flex-1 tw-flex tw-justify-center tw-items-center tw-relative">
            {/* Responsive Image Container */}
            <div className="tw-relative tw-w-[90%] sm:tw-w-[22rem] md:tw-w-[30rem] lg:tw-w-[40rem] tw-border-[6px] sm:tw-border-[8px] lg:tw-border-[10px] tw-border-white tw-overflow-hidden tw-z-[10] lg:tw-absolute lg:tw--top-[15rem] lg:tw--right-[2rem]">
              <img
                src="/images/Group 13_11zon.png"
                alt="Team"
                className="tw-object-contain tw-w-full tw-h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

const cardVariants = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: {
      delay: i * 0.3,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const SectionHighlightsTwo = () => {
  const navigate = useNavigate()
  const cards = [
    {
      text: "What if job hunting actually worked?",
      classes: "!tw--translate-y-6 tw-z-[10]",
    },
    {
      text: "What if AI could match you with roles that fit your actual potential?",
      classes: "!tw-translate-y-[7rem] !tw--ml-[12rem] tw-z-[20]",
    },
    {
      text: "What if your resume could adapt instantly to any job?",
      classes: "!tw--translate-y-[1rem] !tw--ml-[2.5rem] tw-z-[30]",
    },
    {
      text: "What if you knew exactly what skills you were missing and how to get them fast?",
      classes: "!tw-translate-y-[7rem] !tw--ml-[8rem] tw-z-[40]",
    },
  ];

  const fullText = "One platform where everything clicks.";
  const [typedText, setTypedText] = useState("");
  const [hasTyped, setHasTyped] = useState(false);
  const sectionRef = useRef(null);

  // Typewriter trigger
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTyped) {
          setHasTyped(true);
          let i = 0;
          const interval = setInterval(() => {
            setTypedText(fullText.slice(0, i + 1));
            i++;
            if (i === fullText.length) clearInterval(interval);
          }, 60);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasTyped]);

  return (
    <section
      className="tw-relative tw-container tw-mx-auto tw-text-white tw-py-24 tw-px-4 tw-z-10"
      ref={sectionRef}
    >
      <div className="tw-max-w-[1440px] tw-mx-auto tw-relative">
        {/* Title and Subtitle */}
        <h2 style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }} className="tw-text-[2rem] sm:tw-text-[50px] tw-font-bold tw-mb-4">
          The Solution That Made Sense
        </h2>
        <div className="tw-text-[24px] tw-mb-[120px]">
          Instead of building another job board, we asked
        </div>

        {/* === Mobile View: Vertical stacked cards === */}
        <div className="tw-flex tw-flex-col tw-gap-6 desk:tw-hidden">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              className="tw-bg-[#ffffff1a] tw-backdrop-blur-sm tw-text-[18px] tw-rounded-xl tw-p-4 tw-shadow-lg"
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
            >
              {card.text}
            </motion.div>
          ))}
        </div>

        {/* === Desktop View: Overlapped cards === */}
        <div className="tw-hidden desk:tw-flex tw-flex-wrap tw-justify-center tw-gap-y-[-3rem] tw-relative tw-px-2">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              className={`tw-bg-[#ffffff1a] tw-backdrop-blur-sm tw-text-[22px] tw-rounded-xl tw-p-6 tw-shadow-lg tw-w-[390px] ${card.classes}`}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
            >
              {card.text}
            </motion.div>
          ))}
        </div>

        {/* === Inline logo and typewriter === */}
        <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2 sm:tw-gap-3 tw-text-[22px] sm:tw-text-[25px] tw-mt-[80px] sm:tw-mt-[150px] tw-leading-snug">
          <span>That's</span>

          {/* Wrap logo and dot together */}
          <div className="tw-flex tw-items-center">
            <div
              onClick={() => navigate("/")}
              className="tw-relative tw-w-[10rem] tw-h-[2.5rem] tw-flex-shrink-0"
            >
              <img
                src="/images/img_subtract.svg"
                alt="SeekJobs Background"
                className="tw-h-full"
              />
              <img
                src="/images/img_vector_1.svg"
                alt="SeekJobs Icon"
                className="tw-absolute tw-top-[0.5rem] tw-left-[1.5rem] tw-w-[12px] tw-h-[21px]"
              />
              <img
                src="/images/img_seekjobs.svg"
                alt="SeekJobs Text"
                className="tw-absolute tw-top-[0.5rem] tw-left-[2.6rem] tw-w-[7rem]"
              />
            </div>

            {/* Dot moved closer to logo */}
            <span className="tw-ml-1">-</span>
          </div>

          {/* Typed text on same line, responsive */}
          <span className="tw-whitespace-nowrap">{typedText}</span>
        </div>


      </div>
    </section>
  );
};

const SectionHighlightsThree = () => {
  const [swipeUp, setSwipeUp] = useState(false);
  const navigate = useNavigate()
  // Detect swipe up/down on mobile
  // useEffect(() => {
  //   if (window.innerWidth > 768) return; // Only mobile

  //   let touchStartY = 0;

  //   const handleTouchStart = (e) => {
  //     touchStartY = e.touches[0].clientY;
  //   };

  //   const handleTouchMove = (e) => {
  //     const touchEndY = e.touches[0].clientY;
  //     const diffY = touchStartY - touchEndY;

  //     if (diffY > 50) {
  //       setSwipeUp(true); // swipe up
  //     } else if (diffY < -50) {
  //       setSwipeUp(false); // swipe down
  //     }
  //   };

  //   window.addEventListener("touchstart", handleTouchStart);
  //   window.addEventListener("touchmove", handleTouchMove);

  //   return () => {
  //     window.removeEventListener("touchstart", handleTouchStart);
  //     window.removeEventListener("touchmove", handleTouchMove);
  //   };
  // }, []);

  return (
    <section className="tw-relative tw-text-white lg:tw-py-16 md:tw-py-16 sm:tw-py-5 tw-px-4 tw-container tw-mx-auto tw-z-10">
      <div className="tw-max-w-[1440px] tw-mx-auto">
        <h2 style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }} className="tw-text-center tw-text-[2rem] sm:tw-text-[50px]  tw-font-bold tw-mb-[100px]">
          Who We're Built For
        </h2>

        <div className="tw-relative tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-12">
          {/* === Job Seekers Card === */}
          <div className="tw-relative tw-flex tw-items-end tw-h-[350px]">
            {/* Image */}
            <img
              src="images/student.svg"
              alt="Student"
              className="tw-hidden md:tw-none lg:tw-block tw-absolute tw-left-0 tw-bottom-[160px] tw-w-[300px] tw-z-0 tw-translate-y-[95px]"
            />

            {/* Card */}
            <div
              className="tw-relative tw-z-10 tw-rounded-xl tw-p-6 tw-w-full"
              style={{
                background: "linear-gradient(to bottom, #D9B68C, #FFD6A5)",
              }}
            >
              <h3 className="tw-text-[#AC7839] tw-text-2xl tw-font-bold tw-mb-2">
                Job Seekers
              </h3>
              <h4 className="tw-text-white tw-font-semibold tw-mb-4">
                Who Are Done with the Chaos
              </h4>
              <p className="tw-text-[#AC7839] tw-text-base tw-leading-relaxed tw-mb-6">
                <span className="tw-text-white">Students</span> figuring out
                their first move, <span className="tw-text-white">Professionals</span> ready to
                level up, <span className="tw-text-white">Career switchers</span> tired of
                starting over. If you want clarity instead of confusion, we're
                your people.
              </p>
              <div
                role="button"
                tabIndex={0}
                onClick={() => navigate("/job-seeker")}
                onKeyDown={(e) => e.key === "Enter" && navigate("/job-seeker")}
                className="tw-flex tw-items-center tw-gap-2 tw-text-[#AC7839] tw-font-semibold cursor-pointer"
              >
                Get Started <FaArrowRight />
              </div>

            </div>
          </div>

          {/* === Career Centers Card (mobile overlap effect) === */}
          <div
            className={`tw-relative tw-w-full ${swipeUp ? "tw-h-[105px]" : "tw-h-[350px]"
              } lg:tw-h-[350px]`}
          >
            <div
              className={`tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-transition-transform tw-duration-500 ${swipeUp
                ? "tw--translate-y-[70%] tw-z-20"
                : "tw-translate-y-0 tw-z-10"
                } lg:tw-static lg:tw-translate-y-0 lg:tw-relative`}
            >
              {/* Image */}
              <img
                src="images/university-building.svg"
                alt="University"
                className="tw-hidden md:tw-none lg:tw-block tw-absolute tw-left-[140px] tw-bottom-0 tw-w-[90%] tw-z-0 tw-translate-y-[-65px] "
              />

              {/* Card */}
              <div
                className="tw-relative tw-z-10 tw-rounded-xl tw-p-6 tw-w-full"
                style={{
                  background: "linear-gradient(to bottom, #81BAFD, #AFCDF0)",
                }}
              >
                <h3 className="tw-text-[#571483] tw-text-2xl tw-font-bold tw-mb-2">
                  Career Centers
                </h3>
                <h4 className="tw-text-[#235594] tw-font-semibold tw-mb-4">
                  Ready to Make a Real Impact
                </h4>
                <p className="tw-text-[#571483] tw-text-base tw-leading-relaxed tw-mb-6">
                  <span className="tw-text-[#235594]">University </span> teams who know their students deserve better than{" "}
                  <span className="tw-text-[#235594]">generic career advice</span> and{" "}
                  <span className="tw-text-[#235594]">outdated job boards.</span> You want to see actual placement numbers, not just good intentions.
                </p>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate("/career-centers")}
                  onKeyDown={(e) => e.key === "Enter" && navigate("/career-centers")}
                  className="tw-flex tw-items-center tw-gap-2 tw-text-[#571483] tw-font-semibold cursor-pointer"
                >
                  Get Started <FaArrowRight />
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionHighlightsFour = () => {
  const [typedText, setTypedText] = useState("");
  const [hasTyped, setHasTyped] = useState(false);
  const textRef = useRef();
  const sectionRef = useRef();

  const fullText = `What Drives Us Every Day`;

  // Typewriter animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTyped) {
          setHasTyped(true);
          let i = 0;
          const interval = setInterval(() => {
            setTypedText(fullText.slice(0, i + 1));
            i++;
            if (i === fullText.length) clearInterval(interval);
          }, 60);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, [hasTyped, fullText]);

  return (
    <section
      ref={sectionRef}
      className="tw-relative tw-text-white tw-py-16 tw-px-4 tw-container tw-mx-auto"
    >
      <div className="tw-max-w-[1440px] tw-mx-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-items-center tw-gap-10">
        {/* Left Text Block */}
        <div>
          <h2
            style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }}
            ref={textRef}
            className="tw-text-[2rem] sm:tw-text-[36px] tw-font-bold tw-mb-6 tw-whitespace-pre-wrap"
          >
            {typedText}
          </h2>
          <p className="tw-text-[#cbd5e1] tw-text-lg tw-leading-relaxed tw-mb-6">
            We believe career success shouldn't depend on how good you are at
            <strong className="tw-font-semibold tw-text-white"> navigating broken systems</strong>.
            It should depend on your potential, your effort, and having the right tools at the right time.
          </p>
          <p className="tw-text-white tw-font-medium tw-text-lg">
            Every feature we build, every partnership we make, every student who lands their dream job—
            it all comes back to this: Your career deserves better than basic.
          </p>
        </div>

        {/* Right Sticky Image Block */}
        <div className="tw-relative tw-flex tw-justify-center">
          <div className="tw-sticky tw-top-32 tw--rotate-[8deg] tw-shadow-lg tw-inline-block tw-max-w-md">
            {/* Main Image */}
            <img
              src="images/shutterstock-2328775169-10.png"
              alt="Team working"
              className="tw-rounded tw-w-full"
            />

            {/* Top-right Tape Image */}
            <img
              src="images/image-440.png"
              alt="Top-right tape"
              className="tw-absolute tw-top-[-40px] tw-right-[-40px] tw-w-[8rem] tw-rotate-[40deg] tw-translate-x-[8px] tw-translate-y-[-8px]"
            />

            {/* Bottom-left Tape Image */}
            <img
              src="images/image-440.png"
              alt="Bottom-left tape"
              className="tw-absolute tw-bottom-[-40px] tw-left-[-40px] tw-w-[8rem] tw-rotate-[230deg] tw-translate-x-[-8px] tw-translate-y-[8px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionHighlightsFive = () => {
  const cards = [
    {
      title: "IMPACT",
      desc: 'Every decision starts with "Does this help someone get hired?',
      color: "#ffd6a5",
      image: "images/impact1.svg",
    },
    {
      title: "AUTHENTICITY",
      desc: "Real solutions for real problems, no startup BS",
      color: "#caffbf",
      image: "images/medal0.svg",
    },
    {
      title: "SPEED",
      desc: "Career opportunities wait for no one",
      color: "#9bf6ff",
      image: "images/speed1.svg",
    },
    {
      title: "INTELLIGENCE",
      desc: "Work smarter, not harder—for everyone",
      color: "#a0c4ff",
      image: "images/bulb0.svg",
    },
    {
      title: "GROWTH",
      desc: "Your success fuels our innovation",
      color: "#bdb2ff",
      image: "images/growth1.svg",
    },
  ];

  return (
    <section className="tw-container tw-mx-auto tw-p-[30px]">
      <div className="tw-max-w-[1440px] tw-mx-auto tw-space-y-6">
        {/* First row: 3 cards */}
        <h2
          className="tw-text-center tw-font-inter tw-font-semibold tw-text-[36px] md:tw-text-[48px] lg:tw-text-[64px] tw-leading-tight tw-text-global-6 tw-mb-8"
          style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }}
        >
          Our Core Values
        </h2>
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6">
          {cards.slice(0, 3).map((item, idx) => (
            <Card item={item} idx={idx} key={idx} />
          ))}
        </div>

        {/* Second row: 2 cards at 50% width */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6">
          {cards.slice(3).map((item, idx) => (
            <Card item={item} idx={idx + 3} key={idx + 3} />
          ))}
        </div>
      </div>
    </section>
  );
};
const SectionHighlightsSix = () => {
  const navigate = useNavigate()
  return (
    <section className="tw-bg-gradient-to-b tw-from-[#081933] tw-to-[#184B99] tw-rounded-[12px] tw-relative tw-overflow-hidden">
      <img
        src="/images/img_image_8.png"
        alt="Background"
        className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      />
      {/* Blue overlay */}
      <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b tw-from-[#081933]/70 tw-to-[#184B99]/70"></div>

      <div className="tw-relative tw-z-10 tw-py-16 tw-px-4 md:tw-px-16 lg:tw-px-32 tw-text-center">
        <h2
          className="tw-font-inter tw-font-semibold tw-text-[36px] md:tw-text-[48px] lg:tw-text-[64px] tw-leading-tight tw-text-global-6 tw-mb-8"
          style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }}
        >
          Ready to see what job hunting looks like when it actually works?
        </h2>
        <div className="tw-flex tw-justify-center tw-gap-4 tw-flex-wrap">
          <button
            className="tw-bg-white tw-px-6 tw-py-3 tw-rounded-lg tw-border-none tw-font-bold"
          >
            <span onClick={() => navigate("/sign-up")} className="tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB]">
              Experience SeekJobs
            </span>
          </button>

        </div>
      </div>
    </section>
  );
};

const Card = ({ item, idx }) => {
  const isTopImage = idx < 3;
  const imageClass = isTopImage
    ? idx === 2
      ? "tw-w-[9rem] tw-h-21 tw-object-contain tw-object-top tw-absolute tw-top-[-46px] tw-right-[40px]"
      : "tw-w-20 tw-h-21 tw-object-contain tw-object-top tw-absolute tw-top-[-6px] tw-right-[40px]"
    : "tw-w-20 tw-h-20 tw-object-contain tw-object-bottom tw-absolute tw-bottom-[-6px] tw-right-[40px]";

  return (
    <div
      className="tw-rounded-3xl tw-border tw-border-solid tw-backdrop-blur-md tw-relative tw-overflow-hidden tw-transition-all tw-duration-300 hover:tw--translate-y-2 hover:tw-shadow-xl hover:tw-scale-[1.02]"
      style={{
        background: item.color,
        borderImageSlice: "1",
      }}
    >
      <img src={item.image} alt={item.title} className={imageClass} />
      <div className="tw-p-6 tw-flex tw-flex-col-reverse tw-h-full tw-justify-between tw-relative tw-z-10">
        <p className="tw-text-[#235594] tw-text-lg tw-mt-2">{item.desc}</p>
        <h3 className="tw-text-[#235594] tw-text-[28px] lg:tw-text-[32px] tw-font-semibold">
          {item.title}
        </h3>
      </div>
    </div>
  );
};



// Main AboutUs Component
function AboutUs() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div style={{ marginTop: "65px" }} className="text-white font-inter min-h-screen w-full relative overflow-hidden tw-scrollbar-hidden">
      <div className="tw-relative tw-z-10 ">

        {/* ✅ Header & First Section without dots */}
        <Header onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
        <div
          className="tw-w-full tw-text-white"

        >
          <SectionHighlights />
        </div>

        {/* ✅ Next Sections WITH dotted background */}
        <div
          className="tw-w-full tw-text-white"

        >
          {/* 🔽 Dotted BG applied only here 🔽 */}
          <div
            className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen -tw-z-10"
            style={{
              backgroundColor: '#070709', // Fallback
              backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.8) 1px, transparent 1px), linear-gradient(to bottom, #081933, #070709)`,
              backgroundSize: `30px 30px, 100% 100%`,
            }}
          />
          <ImageSection />
          <SectionHighlightsOne />
          <SectionHighlightsTwo />
          <SectionHighlightsThree />
          <SectionHighlightsFour />
        </div>

        <div
          className="tw-w-full tw-text-white"

        >
          {/* 🔽 Dotted BG again if needed 🔽 */}
          <div
            className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen -tw-z-10"
            style={{
              backgroundColor: '#070709', // Fallback
              backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.8) 1px, transparent 1px), linear-gradient(to bottom, #081933, #070709)`,
              backgroundSize: `30px 30px, 100% 100%`,
            }}
          />

          <SectionHighlightsFive />
          <SectionHighlightsSix />

          <div className="tw-relative tw-h-auto">
            <CareerFooter theme="dark" />
          </div>
        </div>
      </div>
    </div>

  );
}

export default AboutUs;
